<script setup>
import configuration from '@/provider/configuration.js'
import { onBeforeMount, onMounted, ref } from 'vue'
import { initialize, load } from '@/services/extranetBarService.js'

const $extranetBar = ref(null);
const config = configuration.getConfig()

onBeforeMount(() => {
  load(config.extranetBar.url)
})
onMounted(() => {
  initialize($extranetBar, config.extranetBar.configuration)
})
</script>

<template>
  <div ref="$extranetBar">
    <extranet-header ></extranet-header>
  </div>
</template>

<style scoped></style>
